import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, vModelRadio as _vModelRadio, Teleport as _Teleport, vModelCheckbox as _vModelCheckbox } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "rounded bg-white p-3 mb-4"
};
const _hoisted_2 = { class: "row mb-5" };
const _hoisted_3 = { class: "col-lg-6 col-12" };
const _hoisted_4 = {
    key: 0,
    class: "badge text-bg-primary text-white"
};
const _hoisted_5 = { class: "table mb-3" };
const _hoisted_6 = ["href"];
const _hoisted_7 = { class: "form-floating mb-3" };
const _hoisted_8 = { class: "form-floating mb-3" };
const _hoisted_9 = ["value"];
const _hoisted_10 = { class: "form-floating mb-3" };
const _hoisted_11 = ["value"];
const _hoisted_12 = { class: "form-floating mb-3" };
const _hoisted_13 = ["value"];
const _hoisted_14 = {
    key: 0,
    class: "form-floating mb-3"
};
const _hoisted_15 = ["value"];
const _hoisted_16 = {
    key: 1,
    class: "form-floating mb-3"
};
const _hoisted_17 = ["value"];
const _hoisted_18 = {
    key: 2,
    class: "form-floating mb-3"
};
const _hoisted_19 = ["value"];
const _hoisted_20 = { class: "form-floating mb-3" };
const _hoisted_21 = {
    key: 3,
    type: "submit",
    class: "btn btn-success d-inline-flex align-items-center mb-4"
};
const _hoisted_22 = {
    key: 1,
    class: "btn btn-primary text-white d-inline-flex align-items-center mb-3",
    "data-bs-toggle": "modal",
    "data-bs-target": "#createOrder"
};
const _hoisted_23 = {
    key: 0,
    class: "col-lg-6 col-12"
};
const _hoisted_24 = { class: "form-floating mb-3" };
const _hoisted_25 = { class: "form-floating mb-3" };
const _hoisted_26 = ["value"];
const _hoisted_27 = { class: "table table-hover align-middle" };
const _hoisted_28 = ["href"];
const _hoisted_29 = ["onClick"];
const _hoisted_30 = {
    key: 0,
    class: "btn btn-secondary d-inline-flex align-items-center mb-3",
    "data-bs-toggle": "modal",
    "data-bs-target": "#createPosition"
};
const _hoisted_31 = { class: "table" };
const _hoisted_32 = {
    key: 0,
    scope: "col"
};
const _hoisted_33 = { class: "align-middle" };
const _hoisted_34 = { class: "align-middle" };
const _hoisted_35 = { key: 1 };
const _hoisted_36 = ["onClick"];
const _hoisted_37 = { class: "align-middle" };
const _hoisted_38 = {
    class: "d-flex align-items-center mt-1",
    style: { "height": "40px" }
};
const _hoisted_39 = {
    class: "d-flex align-items-center mt-1",
    style: { "height": "40px" }
};
const _hoisted_40 = { class: "align-middle" };
const _hoisted_41 = ["onUpdate:modelValue"];
const _hoisted_42 = {
    key: 1,
    class: "d-flex align-items-center mt-1",
    style: { "height": "40px" }
};
const _hoisted_43 = { class: "mt-1" };
const _hoisted_44 = ["onUpdate:modelValue"];
const _hoisted_45 = {
    key: 1,
    class: "d-flex align-items-center mt-1",
    style: { "height": "40px" }
};
const _hoisted_46 = { class: "align-middle" };
const _hoisted_47 = {
    class: "d-flex align-items-center mt-1",
    style: { "height": "40px" }
};
const _hoisted_48 = { class: "mt-1" };
const _hoisted_49 = {
    class: "d-flex align-items-center",
    style: { "height": "40px" }
};
const _hoisted_50 = { class: "align-middle" };
const _hoisted_51 = {
    key: 0,
    class: "input-group",
    style: { "width": "200px" }
};
const _hoisted_52 = ["onUpdate:modelValue"];
const _hoisted_53 = { key: 1 };
const _hoisted_54 = { class: "mt-1 d-flex align-items-center" };
const _hoisted_55 = {
    key: 0,
    class: "input-group",
    style: { "width": "200px" }
};
const _hoisted_56 = ["onUpdate:modelValue"];
const _hoisted_57 = { key: 1 };
const _hoisted_58 = ["onClick"];
const _hoisted_59 = ["onClick"];
const _hoisted_60 = {
    key: 0,
    class: "align-middle"
};
const _hoisted_61 = ["onClick"];
const _hoisted_62 = ["onClick"];
const _hoisted_63 = { class: "row" };
const _hoisted_64 = { class: "col-12 col-lg-6 col-xl-4" };
const _hoisted_65 = { class: "table align-middle" };
const _hoisted_66 = { class: "d-block fw-bold" };
const _hoisted_67 = {
    key: 0,
    class: "fw-bold small"
};
const _hoisted_68 = { key: 1 };
const _hoisted_69 = { class: "d-block fw-bold" };
const _hoisted_70 = { class: "fw-bold" };
const _hoisted_71 = { class: "fw-bold" };
const _hoisted_72 = { class: "bg-light" };
const _hoisted_73 = { class: "fs-5 text-primary fw-bold" };
const _hoisted_74 = {
    class: "modal fade",
    id: "createPosition",
    tabindex: "-1",
    "aria-labelledby": "createPositionModalLabel",
    "aria-hidden": "true"
};
const _hoisted_75 = { class: "modal-dialog modal-dialog-centered modal-lg" };
const _hoisted_76 = { class: "modal-content" };
const _hoisted_77 = { class: "modal-body" };
const _hoisted_78 = { class: "form-floating mb-3" };
const _hoisted_79 = { class: "form-check" };
const _hoisted_80 = { class: "form-check mb-3" };
const _hoisted_81 = { key: 0 };
const _hoisted_82 = { class: "form-check" };
const _hoisted_83 = { class: "form-check mb-3" };
const _hoisted_84 = {
    key: 0,
    class: "mb-3"
};
const _hoisted_85 = {
    key: 1,
    class: "mb-3"
};
const _hoisted_86 = { key: 1 };
const _hoisted_87 = {
    key: 0,
    class: "mb-3"
};
const _hoisted_88 = {
    class: "modal fade",
    id: "createOrder",
    tabindex: "-1",
    "aria-labelledby": "createOrderModalLabel",
    "aria-hidden": "true"
};
const _hoisted_89 = { class: "modal-dialog modal-dialog-centered modal-lg" };
const _hoisted_90 = { class: "modal-content" };
const _hoisted_91 = { class: "modal-body" };
const _hoisted_92 = { class: "form-floating mb-3" };
const _hoisted_93 = { class: "form-floating mb-3" };
const _hoisted_94 = { class: "form-floating mb-3" };
const _hoisted_95 = ["value"];
const _hoisted_96 = { class: "form-floating mb-3" };
const _hoisted_97 = ["value"];
const _hoisted_98 = { class: "form-check mb-3" };
const _hoisted_99 = { class: "form-check mb-3" };
import TenantLayout from '@/Tenant/Layouts/TenantLayout.vue';
import { Head, Link, router, useForm, usePage } from '@inertiajs/vue3';
import { onMounted, ref, watch } from 'vue';
import { formatters } from '@/Composables/formatters';
import { responseMessages } from '@/Composables/responseMessages';
import { Modal } from 'bootstrap';
import { Select, useConfirm } from 'primevue';
import axios from "axios";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Edit',
    props: {
        orderRequest: {
            type: Object,
            required: true
        },
        orderPositions: Object,
        orderRequestTypes: Object,
        orderRequestChannels: Object,
        offers: Object,
        deliveryTypes: Object,
        availableContactUsers: Object
    },
    setup(__props) {
        let { showPageFlashMessage, showErrorMessage, showSuccessMessage } = responseMessages();
        let { formatCurrency, formatDate } = formatters();
        const props = __props;
        const confirm = useConfirm();
        const createPositionModal = ref(null);
        const createOrderModal = ref(null);
        const editOrderRequestForm = useForm({
            name: props.orderRequest?.name,
            adminNotes: props.orderRequest?.adminNotes,
            requestTypeId: props.orderRequest?.type?.id,
            requestChannelId: props.orderRequest?.channel?.id,
            countryId: props.orderRequest?.country?.id,
            deliveryTypeUuid: props.orderRequest?.deliveryType?.uuid,
            customerUuid: props.orderRequest?.customer?.uuid,
            customerAddressUuid: props.orderRequest?.customerAddress?.uuid
        });
        const countries = usePage().props.countries;
        const customerList = ref([]);
        const customerAddressList = ref([]);
        const availableConfigurationsForAllocation = ref([]);
        const availableConfigurationsForCopy = ref([]);
        const availableAccessoryProducts = ref([]);
        const createOrderPositionForm = useForm({
            amount: 100,
            configurationUuid: null,
            accessoryProductUuid: null,
            option: null,
            configurationOrProduct: null
        });
        const createOrderPositionPriceOptionForm = useForm({
            amount: 100
        });
        const orderRequestsOfferForm = useForm({
            notes: null,
            contactUser: null
        });
        const checkoutForm = useForm({
            vatId: null,
            requestedDeliveryDate: null,
            advertisingPurpose: false,
            deliveryType: null,
            invoiceAddress: null,
            deliveryAddress: null,
            paymentByBankTransfer: false
        });
        onMounted(() => {
            const modalElement = document.getElementById('createPosition');
            if (modalElement) {
                createPositionModal.value = new Modal(modalElement);
            }
            const createOrderModalElement = document.getElementById('createOrder');
            if (createOrderModalElement) {
                createOrderModal.value = new Modal(createOrderModalElement);
            }
            loadAvailableCustomers();
            if (editOrderRequestForm.customerUuid) {
                loadCustomersAdresses();
            }
        });
        watch(() => editOrderRequestForm.customerUuid, (newValue) => {
            if (newValue) {
                loadCustomersAdresses();
            }
        });
        watch(() => createOrderPositionForm.option, (newValue) => {
            if (newValue == 1) {
                loadAvailableConfigurationsForAllocation();
            }
            else if (newValue == 2) {
                loadAvailableConfigurationsForCopy();
            }
        });
        watch(() => createOrderPositionForm.configurationOrProduct, (newValue) => {
            if (newValue == 2) {
                loadAvailableAccessoryProducts();
            }
        });
        function loadAvailableCustomers() {
            axios.post(route('admin.customers.load'))
                .then(function (response) {
                customerList.value = response.data;
            })
                .catch(function (error) {
                console.log(error);
            });
        }
        function loadCustomersAdresses() {
            if (editOrderRequestForm.customerUuid == null) {
                return;
            }
            axios.post(route('admin.customers.addresses.load', editOrderRequestForm.customerUuid))
                .then(function (response) {
                customerAddressList.value = response.data;
            })
                .catch(function (error) {
                console.log(error);
            });
        }
        function updateOrderRequest() {
            if (props.orderRequest == null) {
                return;
            }
            editOrderRequestForm.transform((data) => ({
                name: data.name,
                admin_notes: data.adminNotes,
                request_type_id: data.requestTypeId,
                request_channel_id: data.requestChannelId,
                country_id: data.countryId,
                customer_uuid: data.customerUuid,
                customer_address_uuid: data.customerAddressUuid,
                delivery_type_uuid: data.deliveryTypeUuid
            })).submit('put', route('admin.orderRequests.update', props.orderRequest.uuid), {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function removeOrderRequest() {
            if (props.orderRequest == null || props.orderRequest.order != null) {
                return;
            }
            confirm.require({
                message: 'Soll die Anfrage wirklich gelöscht werden?',
                header: 'Anfrage/Angebot löschen?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    if (props.orderRequest == null) {
                        return;
                    }
                    router.delete(route('admin.orderRequests.destroy', props.orderRequest.uuid), {
                        preserveScroll: true,
                        onSuccess: page => {
                            showPageFlashMessage(page);
                        },
                        onError: errors => {
                            console.log(errors);
                            showErrorMessage(errors[0]);
                        }
                    });
                },
                reject: () => {
                    confirm.close();
                }
            });
        }
        function loadAvailableConfigurationsForAllocation() {
            axios.post(route('admin.configurations.load'), {
                type: 'allocation'
            }).then((response) => {
                availableConfigurationsForAllocation.value = response.data;
            }).catch((error) => {
                console.log(error);
            });
        }
        function loadAvailableConfigurationsForCopy() {
            axios.post(route('admin.configurations.load'), {
                type: 'copy'
            }).then((response) => {
                availableConfigurationsForCopy.value = response.data;
            }).catch((error) => {
                console.log(error);
            });
        }
        function loadAvailableAccessoryProducts() {
            axios.post(route('admin.accessoryProducts.load'))
                .then((response) => {
                availableAccessoryProducts.value = response.data;
            }).catch((error) => {
                console.log(error);
            });
        }
        function createOrderPosition() {
            if (props.orderRequest == null) {
                return;
            }
            createOrderPositionForm.transform((data) => ({
                amount: data.amount,
                configuration_uuid: data.configurationUuid,
                accessory_product_uuid: data.accessoryProductUuid,
                copy: data.option == 2 ? true : false
            })).submit('post', route('admin.orderPositions.store', props.orderRequest.uuid), {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                    createOrderPositionForm.reset();
                    createPositionModal.value?.hide();
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function updateOrderPosition(position) {
            router.put(route('admin.orderPositions.update', position.uuid), {
                amount: position.amount,
                custom_total_price: position.customTotalPrice
            }, {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function removeOrderPosition(uuid) {
            if (props.orderRequest.order != null) {
                return;
            }
            confirm.require({
                message: 'Soll die Position wirklich gelöscht werden?',
                header: 'Position löschen?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    router.delete(route('admin.orderPositions.destroy', uuid), {
                        preserveScroll: true,
                        onSuccess: page => {
                            showPageFlashMessage(page);
                        },
                        onError: errors => {
                            console.log(errors);
                            showErrorMessage(errors[0]);
                        }
                    });
                },
                reject: () => {
                    confirm.close();
                }
            });
        }
        function createOrderPositionPriceOption(orderPositionUuid) {
            createOrderPositionPriceOptionForm.transform((data) => ({
                amount: data.amount
            })).submit('post', route('admin.orderPositions.priceOptions.store', orderPositionUuid), {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                    createOrderPositionPriceOptionForm.reset();
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function updateOrderPositionPriceOption(priceOption) {
            router.put(route('admin.orderPositions.priceOptions.update', priceOption.uuid), {
                amount: priceOption.amount,
                custom_total_price: priceOption.customTotalPrice
            }, {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function removeOrderPositionPriceOption(uuid) {
            if (props.orderRequest.order != null) {
                return;
            }
            confirm.require({
                message: 'Soll die Option wirklich gelöscht werden?',
                header: 'Option löschen?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    router.delete(route('admin.orderPositions.priceOptions.destroy', uuid), {
                        preserveScroll: true,
                        onSuccess: page => {
                            showPageFlashMessage(page);
                        },
                        onError: errors => {
                            console.log(errors);
                            showErrorMessage(errors[0]);
                        }
                    });
                },
                reject: () => {
                    confirm.close();
                }
            });
        }
        function createOffer() {
            confirm.require({
                message: 'Soll wirklich ein neues Angebot erstellt werden?',
                header: 'Neues Angebot erstellen?',
                acceptLabel: 'Ja, erstellen',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    if (props.orderRequest == null) {
                        return;
                    }
                    router.post(route('admin.orderRequests.offers.store', props.orderRequest.uuid), {
                        notes: orderRequestsOfferForm.notes,
                        contactUser: orderRequestsOfferForm.contactUser
                    }, {
                        preserveScroll: true,
                        onSuccess: page => {
                            showPageFlashMessage(page);
                        },
                        onError: errors => {
                            console.log(errors);
                            showErrorMessage(errors[0]);
                        }
                    });
                },
                reject: () => {
                    confirm.close();
                }
            });
        }
        function resendOffer(offerUuid) {
            confirm.require({
                message: 'Soll das Angebot wirklich (erneut) versendet werden?',
                header: 'Angebot (erneut) versenden?',
                acceptLabel: 'Ja, versenden',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    router.post(route('admin.orderRequests.offers.resend', offerUuid), {}, {
                        preserveScroll: true,
                        onSuccess: page => {
                            showPageFlashMessage(page);
                        },
                        onError: errors => {
                            console.log(errors);
                            showErrorMessage(errors[0]);
                        }
                    });
                },
                reject: () => {
                    confirm.close();
                }
            });
        }
        function createOrder() {
            confirm.require({
                message: 'Bestellung erstellen und Bestätigung inkl. Zahlungsanweisungen versenden?',
                header: 'Bestellung erstellen?',
                acceptLabel: 'Ja, erstellen',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    checkoutForm.transform((data) => ({
                        vat_id: data.vatId,
                        requested_delivery_date: data.requestedDeliveryDate,
                        advertising_purpose: data.advertisingPurpose ? 1 : 0,
                        invoice_address_uuid: data.invoiceAddress,
                        delivery_address_uuid: data.deliveryAddress,
                        payment_by_bank_transfer: data.paymentByBankTransfer ? 1 : 0
                    })).submit('post', route('admin.orders.store', props.orderRequest.uuid), {
                        preserveScroll: true,
                        onSuccess: page => {
                            showPageFlashMessage(page);
                            checkoutForm.reset();
                            createOrderModal.value?.hide();
                        },
                        onError: errors => {
                            console.log(errors);
                            showErrorMessage(errors[0]);
                        }
                    });
                },
                reject: () => {
                    confirm.close();
                }
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(Head), { title: "Anfrage-Details" }),
                _createVNode(TenantLayout, null, {
                    default: _withCtx(() => [
                        _cache[71] || (_cache[71] = _createElementVNode("h1", { class: "fw-bold mb-3" }, "Anfrage/Angebot", -1)),
                        (props.orderRequest)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createElementVNode("div", _hoisted_2, [
                                    _createElementVNode("div", _hoisted_3, [
                                        (props.orderRequest.order)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Bestellung erstellt"))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("table", _hoisted_5, [
                                            _createElementVNode("tbody", null, [
                                                _createElementVNode("tr", null, [
                                                    _cache[25] || (_cache[25] = _createElementVNode("th", null, "Anfrage vom", -1)),
                                                    _createElementVNode("td", null, _toDisplayString(_unref(formatDate)(props.orderRequest.createdAt, true)) + " Uhr", 1)
                                                ]),
                                                _createElementVNode("tr", null, [
                                                    _cache[26] || (_cache[26] = _createElementVNode("th", null, "Letzte Änderung", -1)),
                                                    _createElementVNode("td", null, _toDisplayString(_unref(formatDate)(props.orderRequest.updatedAt, true)) + " Uhr", 1)
                                                ]),
                                                _createElementVNode("tr", null, [
                                                    _cache[27] || (_cache[27] = _createElementVNode("th", null, "UUID", -1)),
                                                    _createElementVNode("td", null, _toDisplayString(props.orderRequest.uuid), 1)
                                                ]),
                                                _createElementVNode("tr", null, [
                                                    _cache[28] || (_cache[28] = _createElementVNode("th", null, "Externer Link", -1)),
                                                    _createElementVNode("td", null, [
                                                        _createElementVNode("a", {
                                                            href: props.orderRequest.externalUrl,
                                                            target: "_blank"
                                                        }, _toDisplayString(props.orderRequest.externalUrl), 9, _hoisted_6)
                                                    ])
                                                ]),
                                                _createElementVNode("tr", null, [
                                                    _cache[29] || (_cache[29] = _createElementVNode("th", null, "Kunden-Sprache", -1)),
                                                    _createElementVNode("td", null, _toDisplayString(props.orderRequest.customer ? props.orderRequest.customer.lang : '-'), 1)
                                                ]),
                                                _createElementVNode("tr", null, [
                                                    _cache[30] || (_cache[30] = _createElementVNode("th", null, "Kunden-Anmerkung", -1)),
                                                    _createElementVNode("td", null, _toDisplayString(props.orderRequest.customerNotes), 1)
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("form", {
                                            onSubmit: _withModifiers(updateOrderRequest, ["prevent"])
                                        }, [
                                            _createElementVNode("div", _hoisted_7, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "name",
                                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(editOrderRequestForm).name) = $event))
                                                }, null, 512), [
                                                    [_vModelText, _unref(editOrderRequestForm).name]
                                                ]),
                                                _cache[31] || (_cache[31] = _createElementVNode("label", { for: "name" }, "Name", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_8, [
                                                _withDirectives(_createElementVNode("select", {
                                                    class: "form-select",
                                                    id: "requestType",
                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(editOrderRequestForm).requestTypeId) = $event)),
                                                    required: ""
                                                }, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.orderRequestTypes, (requestType) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                            value: requestType.id
                                                        }, _toDisplayString(requestType.name), 9, _hoisted_9));
                                                    }), 256))
                                                ], 512), [
                                                    [_vModelSelect, _unref(editOrderRequestForm).requestTypeId]
                                                ]),
                                                _cache[32] || (_cache[32] = _createElementVNode("label", { for: "requestType" }, "Typ", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_10, [
                                                _withDirectives(_createElementVNode("select", {
                                                    class: "form-select",
                                                    id: "requestChannel",
                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(editOrderRequestForm).requestChannelId) = $event)),
                                                    required: ""
                                                }, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.orderRequestChannels, (requestChannel) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                            value: requestChannel.id
                                                        }, _toDisplayString(requestChannel.name), 9, _hoisted_11));
                                                    }), 256))
                                                ], 512), [
                                                    [_vModelSelect, _unref(editOrderRequestForm).requestChannelId]
                                                ]),
                                                _cache[33] || (_cache[33] = _createElementVNode("label", { for: "requestChannel" }, "Anfragekanal", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_12, [
                                                _withDirectives(_createElementVNode("select", {
                                                    class: "form-select",
                                                    id: "country",
                                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(editOrderRequestForm).countryId) = $event)),
                                                    required: ""
                                                }, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(countries), (country) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                            value: country.id
                                                        }, _toDisplayString(country.name), 9, _hoisted_13));
                                                    }), 256))
                                                ], 512), [
                                                    [_vModelSelect, _unref(editOrderRequestForm).countryId]
                                                ]),
                                                _cache[34] || (_cache[34] = _createElementVNode("label", { for: "country" }, "Lieferland", -1))
                                            ]),
                                            (_unref(editOrderRequestForm).countryId && props.deliveryTypes.length > 0)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                                    _withDirectives(_createElementVNode("select", {
                                                        class: "form-select",
                                                        id: "deliveryType",
                                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(editOrderRequestForm).deliveryTypeUuid) = $event)),
                                                        required: ""
                                                    }, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.deliveryTypes, (deliveryType) => {
                                                            return (_openBlock(), _createElementBlock("option", {
                                                                value: deliveryType.uuid
                                                            }, _toDisplayString(deliveryType.name), 9, _hoisted_15));
                                                        }), 256))
                                                    ], 512), [
                                                        [_vModelSelect, _unref(editOrderRequestForm).deliveryTypeUuid]
                                                    ]),
                                                    _cache[35] || (_cache[35] = _createElementVNode("label", { for: "deliveryType" }, "Lieferart (bezogen auf Lieferland)", -1))
                                                ]))
                                                : _createCommentVNode("", true),
                                            (customerList.value.length > 0)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                                    _withDirectives(_createElementVNode("select", {
                                                        class: "form-select",
                                                        id: "customer",
                                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_unref(editOrderRequestForm).customerUuid) = $event)),
                                                        required: ""
                                                    }, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customerList.value, (customer) => {
                                                            return (_openBlock(), _createElementBlock("option", {
                                                                value: customer.uuid
                                                            }, _toDisplayString(customer.name), 9, _hoisted_17));
                                                        }), 256))
                                                    ], 512), [
                                                        [_vModelSelect, _unref(editOrderRequestForm).customerUuid]
                                                    ]),
                                                    _cache[36] || (_cache[36] = _createElementVNode("label", { for: "customer" }, "Kunde", -1))
                                                ]))
                                                : _createCommentVNode("", true),
                                            (customerAddressList.value.length > 0)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                                    _withDirectives(_createElementVNode("select", {
                                                        class: "form-select",
                                                        id: "customerAddress",
                                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_unref(editOrderRequestForm).customerAddressUuid) = $event)),
                                                        required: ""
                                                    }, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customerAddressList.value, (address) => {
                                                            return (_openBlock(), _createElementBlock("option", {
                                                                value: address.uuid
                                                            }, _toDisplayString(address.name), 9, _hoisted_19));
                                                        }), 256))
                                                    ], 512), [
                                                        [_vModelSelect, _unref(editOrderRequestForm).customerAddressUuid]
                                                    ]),
                                                    _cache[37] || (_cache[37] = _createElementVNode("label", { for: "customerAddress" }, "Adresse", -1))
                                                ]))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("div", _hoisted_20, [
                                                _withDirectives(_createElementVNode("textarea", {
                                                    class: "form-control",
                                                    id: "adminNotes",
                                                    style: { "height": "100px" },
                                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_unref(editOrderRequestForm).adminNotes) = $event))
                                                }, null, 512), [
                                                    [_vModelText, _unref(editOrderRequestForm).adminNotes]
                                                ]),
                                                _cache[38] || (_cache[38] = _createElementVNode("label", { for: "adminNotes" }, "Admin-Anmerkungen", -1))
                                            ]),
                                            (props.orderRequest.order == null)
                                                ? (_openBlock(), _createElementBlock("button", _hoisted_21, [...(_cache[39] || (_cache[39] = [
                                                        _createElementVNode("svg", {
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            width: "16",
                                                            height: "16",
                                                            fill: "currentColor",
                                                            class: "bi bi-check2",
                                                            viewBox: "0 0 16 16"
                                                        }, [
                                                            _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                                        ], -1),
                                                        _createElementVNode("span", { class: "ms-2" }, "Speichern", -1)
                                                    ]))]))
                                                : _createCommentVNode("", true)
                                        ], 32),
                                        (props.orderRequest.canCreateOrder && customerAddressList.value.length > 0)
                                            ? (_openBlock(), _createElementBlock("button", _hoisted_22, [...(_cache[40] || (_cache[40] = [
                                                    _createElementVNode("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        width: "16",
                                                        height: "16",
                                                        fill: "currentColor",
                                                        class: "bi bi-plus-lg",
                                                        viewBox: "0 0 16 16"
                                                    }, [
                                                        _createElementVNode("path", {
                                                            "fill-rule": "evenodd",
                                                            d: "M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"
                                                        })
                                                    ], -1),
                                                    _createElementVNode("span", { class: "ms-2" }, "Bestellung erstellen", -1)
                                                ]))]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    (props.orderRequest.customer)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                            _cache[47] || (_cache[47] = _createElementVNode("h4", { class: "fw-bold mb-3" }, "Angebote", -1)),
                                            (props.orderRequest.order == null)
                                                ? (_openBlock(), _createElementBlock("form", {
                                                    key: 0,
                                                    onSubmit: _withModifiers(createOffer, ["prevent"])
                                                }, [
                                                    _createElementVNode("div", _hoisted_24, [
                                                        _withDirectives(_createElementVNode("textarea", {
                                                            class: "form-control",
                                                            id: "offerNotes",
                                                            style: { "height": "100px" },
                                                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_unref(orderRequestsOfferForm).notes) = $event))
                                                        }, null, 512), [
                                                            [_vModelText, _unref(orderRequestsOfferForm).notes]
                                                        ]),
                                                        _cache[41] || (_cache[41] = _createElementVNode("label", { for: "offerNotes" }, "Anmerkungen (im Angebot ersichtlich)", -1))
                                                    ]),
                                                    _createElementVNode("div", _hoisted_25, [
                                                        _withDirectives(_createElementVNode("select", {
                                                            class: "form-select",
                                                            id: "contactPerson",
                                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_unref(orderRequestsOfferForm).contactUser) = $event)),
                                                            required: ""
                                                        }, [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.availableContactUsers, (user) => {
                                                                return (_openBlock(), _createElementBlock("option", {
                                                                    value: user.uuid
                                                                }, _toDisplayString(user.name), 9, _hoisted_26));
                                                            }), 256))
                                                        ], 512), [
                                                            [_vModelSelect, _unref(orderRequestsOfferForm).contactUser]
                                                        ]),
                                                        _cache[42] || (_cache[42] = _createElementVNode("label", { for: "contactPerson" }, "Ansprechpartner", -1))
                                                    ]),
                                                    _cache[43] || (_cache[43] = _createElementVNode("button", {
                                                        type: "submit",
                                                        class: "btn btn-primary text-white d-inline-flex align-items-center mb-3"
                                                    }, [
                                                        _createElementVNode("svg", {
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            width: "16",
                                                            height: "16",
                                                            fill: "currentColor",
                                                            class: "bi bi-plus-lg",
                                                            viewBox: "0 0 16 16"
                                                        }, [
                                                            _createElementVNode("path", {
                                                                "fill-rule": "evenodd",
                                                                d: "M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"
                                                            })
                                                        ]),
                                                        _createElementVNode("span", { class: "ms-2" }, "Neues Angebot erstellen")
                                                    ], -1))
                                                ], 32))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("table", _hoisted_27, [
                                                _cache[46] || (_cache[46] = _createElementVNode("thead", null, [
                                                    _createElementVNode("tr", null, [
                                                        _createElementVNode("th", { scope: "col" }, "Angebots-Datum"),
                                                        _createElementVNode("th", { scope: "col" }, "Anmerkung für den Kunden"),
                                                        _createElementVNode("th", { scope: "col" }, "Ansprechpartner"),
                                                        _createElementVNode("th", { scope: "col" }, "Download"),
                                                        _createElementVNode("th", { scope: "col" }, "Letzter Versand"),
                                                        _createElementVNode("th", { scope: "col" }, "(Erneut) zusenden?")
                                                    ])
                                                ], -1)),
                                                _createElementVNode("tbody", null, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.offers, (offer) => {
                                                        return (_openBlock(), _createElementBlock("tr", null, [
                                                            _createElementVNode("td", null, _toDisplayString(_unref(formatDate)(offer.createdAt)), 1),
                                                            _createElementVNode("td", null, [
                                                                _createElementVNode("small", null, _toDisplayString(offer.notes), 1)
                                                            ]),
                                                            _createElementVNode("td", null, _toDisplayString(offer.user ? offer.user.name : '-'), 1),
                                                            _createElementVNode("td", null, [
                                                                _createElementVNode("a", {
                                                                    href: offer.downloadUrl
                                                                }, [...(_cache[44] || (_cache[44] = [
                                                                        _createElementVNode("svg", {
                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                            height: "24",
                                                                            fill: "currentColor",
                                                                            class: "bi bi-file-earmark-pdf",
                                                                            viewBox: "0 0 16 16"
                                                                        }, [
                                                                            _createElementVNode("path", { d: "M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" }),
                                                                            _createElementVNode("path", { d: "M4.603 14.087a.8.8 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.7 7.7 0 0 1 1.482-.645 20 20 0 0 0 1.062-2.227 7.3 7.3 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a11 11 0 0 0 .98 1.686 5.8 5.8 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.86.86 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.7 5.7 0 0 1-.911-.95 11.7 11.7 0 0 0-1.997.406 11.3 11.3 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.8.8 0 0 1-.58.029m1.379-1.901q-.25.115-.459.238c-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361q.016.032.026.044l.035-.012c.137-.056.355-.235.635-.572a8 8 0 0 0 .45-.606m1.64-1.33a13 13 0 0 1 1.01-.193 12 12 0 0 1-.51-.858 21 21 0 0 1-.5 1.05zm2.446.45q.226.245.435.41c.24.19.407.253.498.256a.1.1 0 0 0 .07-.015.3.3 0 0 0 .094-.125.44.44 0 0 0 .059-.2.1.1 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a4 4 0 0 0-.612-.053zM8.078 7.8a7 7 0 0 0 .2-.828q.046-.282.038-.465a.6.6 0 0 0-.032-.198.5.5 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822q.036.167.09.346z" })
                                                                        ], -1)
                                                                    ]))], 8, _hoisted_28)
                                                            ]),
                                                            _createElementVNode("td", null, _toDisplayString(_unref(formatDate)(offer.lastSentAt, true)) + " (" + _toDisplayString(offer.sentCount) + "x versendet)", 1),
                                                            _createElementVNode("td", null, [
                                                                _createElementVNode("button", {
                                                                    class: "btn btn-primary text-white d-inline-flex align-items-center",
                                                                    onClick: ($event) => (resendOffer(offer.uuid))
                                                                }, [...(_cache[45] || (_cache[45] = [
                                                                        _createElementVNode("svg", {
                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                            width: "16",
                                                                            height: "16",
                                                                            fill: "currentColor",
                                                                            class: "bi bi-envelope",
                                                                            viewBox: "0 0 16 16"
                                                                        }, [
                                                                            _createElementVNode("path", { d: "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1zm13 2.383-4.708 2.825L15 11.105zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741M1 11.105l4.708-2.897L1 5.383z" })
                                                                        ], -1)
                                                                    ]))], 8, _hoisted_29)
                                                            ])
                                                        ]));
                                                    }), 256))
                                                ])
                                            ])
                                        ]))
                                        : _createCommentVNode("", true)
                                ]),
                                _cache[70] || (_cache[70] = _createElementVNode("h3", { class: "fw-bold bg-primary text-white mb-4 px-3 py-2" }, "Positionen", -1)),
                                (props.orderRequest.order == null)
                                    ? (_openBlock(), _createElementBlock("button", _hoisted_30, [...(_cache[48] || (_cache[48] = [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "16",
                                                height: "16",
                                                fill: "currentColor",
                                                class: "bi bi-plus-lg",
                                                viewBox: "0 0 16 16"
                                            }, [
                                                _createElementVNode("path", {
                                                    "fill-rule": "evenodd",
                                                    d: "M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"
                                                })
                                            ], -1),
                                            _createElementVNode("span", { class: "ms-2" }, "Neue Position", -1)
                                        ]))]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("table", _hoisted_31, [
                                    _createElementVNode("thead", null, [
                                        _createElementVNode("tr", null, [
                                            _cache[49] || (_cache[49] = _createElementVNode("th", { scope: "col" }, "#", -1)),
                                            _cache[50] || (_cache[50] = _createElementVNode("th", { scope: "col" }, "Produkt/Konfiguration", -1)),
                                            _cache[51] || (_cache[51] = _createElementVNode("th", { scope: "col" }, "Einzelpreis", -1)),
                                            _cache[52] || (_cache[52] = _createElementVNode("th", { scope: "col" }, "Menge", -1)),
                                            _cache[53] || (_cache[53] = _createElementVNode("th", { scope: "col" }, "Gesamt", -1)),
                                            _cache[54] || (_cache[54] = _createElementVNode("th", { scope: "col" }, "Gesamt inviduell", -1)),
                                            (props.orderRequest.order == null)
                                                ? (_openBlock(), _createElementBlock("th", _hoisted_32))
                                                : _createCommentVNode("", true)
                                        ])
                                    ]),
                                    _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.orderPositions, (position, index) => {
                                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                                _createElementVNode("td", _hoisted_33, _toDisplayString(index + 1), 1),
                                                _createElementVNode("td", _hoisted_34, [
                                                    (position.editRoute)
                                                        ? (_openBlock(), _createBlock(_unref(Link), {
                                                            key: 0,
                                                            href: position.editRoute
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(position.productDetails), 1)
                                                            ]),
                                                            _: 2
                                                        }, 1032, ["href"]))
                                                        : (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(position.productDetails), 1)),
                                                    _createElementVNode("div", null, [
                                                        (props.orderRequest.order == null)
                                                            ? (_openBlock(), _createElementBlock("button", {
                                                                key: 0,
                                                                class: "btn d-flex align-items-center",
                                                                onClick: ($event) => (createOrderPositionPriceOption(position.uuid))
                                                            }, [...(_cache[55] || (_cache[55] = [
                                                                    _createElementVNode("svg", {
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        height: "16",
                                                                        fill: "currentColor",
                                                                        class: "text-primary bi bi-plus-circle",
                                                                        viewBox: "0 0 16 16"
                                                                    }, [
                                                                        _createElementVNode("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" }),
                                                                        _createElementVNode("path", { d: "M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" })
                                                                    ], -1),
                                                                    _createElementVNode("span", { class: "ms-2" }, "Preisoption", -1)
                                                                ]))], 8, _hoisted_36))
                                                            : _createCommentVNode("", true)
                                                    ])
                                                ]),
                                                _createElementVNode("td", _hoisted_37, [
                                                    _createElementVNode("div", _hoisted_38, _toDisplayString(_unref(formatCurrency)(position.singlePrice)), 1),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(position.priceOptions, (priceOption) => {
                                                        return (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                                            _createTextVNode(_toDisplayString(_unref(formatCurrency)(priceOption.singlePrice)) + " ", 1),
                                                            _cache[56] || (_cache[56] = _createElementVNode("span", { class: "small fw-bold ms-3" }, "Option", -1))
                                                        ]));
                                                    }), 256))
                                                ]),
                                                _createElementVNode("td", _hoisted_40, [
                                                    (props.orderRequest.order == null)
                                                        ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                                            key: 0,
                                                            type: "number",
                                                            class: "form-control",
                                                            "onUpdate:modelValue": ($event) => ((position.amount) = $event),
                                                            style: { "width": "100px" }
                                                        }, null, 8, _hoisted_41)), [
                                                            [_vModelText, position.amount]
                                                        ])
                                                        : (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(position.amount), 1)),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(position.priceOptions, (priceOption) => {
                                                        return (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                                            (props.orderRequest.order == null)
                                                                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                                                    key: 0,
                                                                    type: "number",
                                                                    class: "form-control",
                                                                    "onUpdate:modelValue": ($event) => ((priceOption.amount) = $event),
                                                                    style: { "width": "100px" }
                                                                }, null, 8, _hoisted_44)), [
                                                                    [_vModelText, priceOption.amount]
                                                                ])
                                                                : (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(priceOption.amount), 1))
                                                        ]));
                                                    }), 256))
                                                ]),
                                                _createElementVNode("td", _hoisted_46, [
                                                    _createElementVNode("div", _hoisted_47, _toDisplayString(_unref(formatCurrency)(position.originTotalPrice ?? position.totalPrice)), 1),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(position.priceOptions, (priceOption) => {
                                                        return (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                                            _createElementVNode("div", _hoisted_49, _toDisplayString(_unref(formatCurrency)(priceOption.originTotalPrice ?? priceOption.totalPrice)), 1)
                                                        ]));
                                                    }), 256))
                                                ]),
                                                _createElementVNode("td", _hoisted_50, [
                                                    (props.orderRequest.order == null)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                                            _withDirectives(_createElementVNode("input", {
                                                                type: "number",
                                                                class: "form-control",
                                                                "onUpdate:modelValue": ($event) => ((position.customTotalPrice) = $event)
                                                            }, null, 8, _hoisted_52), [
                                                                [_vModelText, position.customTotalPrice]
                                                            ]),
                                                            _cache[57] || (_cache[57] = _createElementVNode("span", { class: "input-group-text" }, "€", -1))
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    (props.orderRequest.order && position.originTotalPrice)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(_unref(formatCurrency)(position.totalPrice)), 1))
                                                        : _createCommentVNode("", true),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(position.priceOptions, (priceOption) => {
                                                        return (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                                            (props.orderRequest.order == null)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                                                    _withDirectives(_createElementVNode("input", {
                                                                        type: "number",
                                                                        class: "form-control",
                                                                        "onUpdate:modelValue": ($event) => ((priceOption.customTotalPrice) = $event)
                                                                    }, null, 8, _hoisted_56), [
                                                                        [_vModelText, priceOption.customTotalPrice]
                                                                    ]),
                                                                    _cache[58] || (_cache[58] = _createElementVNode("span", { class: "input-group-text" }, "€", -1))
                                                                ]))
                                                                : _createCommentVNode("", true),
                                                            (props.orderRequest.order && priceOption.originTotalPrice)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_57, _toDisplayString(_unref(formatCurrency)(priceOption.totalPrice)), 1))
                                                                : _createCommentVNode("", true),
                                                            (props.orderRequest.order == null)
                                                                ? (_openBlock(), _createElementBlock("button", {
                                                                    key: 2,
                                                                    class: "btn btn-success d-inline-flex align-items-center mx-3",
                                                                    onClick: ($event) => (updateOrderPositionPriceOption(priceOption))
                                                                }, [...(_cache[59] || (_cache[59] = [
                                                                        _createElementVNode("svg", {
                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                            width: "16",
                                                                            height: "16",
                                                                            fill: "currentColor",
                                                                            class: "bi bi-check2",
                                                                            viewBox: "0 0 16 16"
                                                                        }, [
                                                                            _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                                                        ], -1)
                                                                    ]))], 8, _hoisted_58))
                                                                : _createCommentVNode("", true),
                                                            (props.orderRequest.order == null)
                                                                ? (_openBlock(), _createElementBlock("button", {
                                                                    key: 3,
                                                                    class: "btn btn-danger d-inline-flex align-items-center",
                                                                    onClick: ($event) => (removeOrderPositionPriceOption(priceOption.uuid))
                                                                }, [...(_cache[60] || (_cache[60] = [
                                                                        _createElementVNode("svg", {
                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                            width: "16",
                                                                            height: "16",
                                                                            fill: "currentColor",
                                                                            class: "bi bi-x-circle",
                                                                            viewBox: "0 0 16 16"
                                                                        }, [
                                                                            _createElementVNode("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" }),
                                                                            _createElementVNode("path", { d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" })
                                                                        ], -1)
                                                                    ]))], 8, _hoisted_59))
                                                                : _createCommentVNode("", true)
                                                        ]));
                                                    }), 256))
                                                ]),
                                                (props.orderRequest.order == null)
                                                    ? (_openBlock(), _createElementBlock("td", _hoisted_60, [
                                                        _createElementVNode("button", {
                                                            class: "btn btn-success d-inline-flex align-items-center me-3",
                                                            onClick: ($event) => (updateOrderPosition(position))
                                                        }, [...(_cache[61] || (_cache[61] = [
                                                                _createElementVNode("svg", {
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    width: "16",
                                                                    height: "16",
                                                                    fill: "currentColor",
                                                                    class: "bi bi-check2",
                                                                    viewBox: "0 0 16 16"
                                                                }, [
                                                                    _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                                                ], -1)
                                                            ]))], 8, _hoisted_61),
                                                        _createElementVNode("button", {
                                                            class: "btn btn-danger d-inline-flex align-items-center",
                                                            onClick: ($event) => (removeOrderPosition(position.uuid))
                                                        }, [...(_cache[62] || (_cache[62] = [
                                                                _createElementVNode("svg", {
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    width: "16",
                                                                    height: "16",
                                                                    fill: "currentColor",
                                                                    class: "bi bi-x-circle",
                                                                    viewBox: "0 0 16 16"
                                                                }, [
                                                                    _createElementVNode("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" }),
                                                                    _createElementVNode("path", { d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" })
                                                                ], -1)
                                                            ]))], 8, _hoisted_62)
                                                    ]))
                                                    : _createCommentVNode("", true)
                                            ]));
                                        }), 128))
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_63, [
                                    _createElementVNode("div", _hoisted_64, [
                                        _createElementVNode("table", _hoisted_65, [
                                            _createElementVNode("tbody", null, [
                                                _createElementVNode("tr", null, [
                                                    _cache[64] || (_cache[64] = _createElementVNode("td", null, "Zwischensumme", -1)),
                                                    _createElementVNode("td", null, [
                                                        _createElementVNode("span", _hoisted_66, _toDisplayString(_unref(formatCurrency)(props.orderRequest.subTotalPrice)), 1),
                                                        _cache[63] || (_cache[63] = _createElementVNode("span", { class: "d-block small" }, "exkl. MwSt.", -1))
                                                    ])
                                                ]),
                                                _createElementVNode("tr", null, [
                                                    _createElementVNode("td", null, "Versandkosten (" + _toDisplayString((props.orderRequest.totalWeight / 1000).toFixed(2)) + " kg)", 1),
                                                    (props.orderRequest.deliveryPrice == 0)
                                                        ? (_openBlock(), _createElementBlock("td", _hoisted_67, "Wird vom Kunden während der Bestellung festgelegt."))
                                                        : _createCommentVNode("", true),
                                                    (props.orderRequest.deliveryPrice > 0)
                                                        ? (_openBlock(), _createElementBlock("td", _hoisted_68, [
                                                            _createElementVNode("span", _hoisted_69, _toDisplayString(_unref(formatCurrency)(props.orderRequest.deliveryPrice)), 1),
                                                            _cache[65] || (_cache[65] = _createElementVNode("span", { class: "d-block small" }, "exkl. MwSt.", -1))
                                                        ]))
                                                        : _createCommentVNode("", true)
                                                ]),
                                                _createElementVNode("tr", null, [
                                                    _cache[66] || (_cache[66] = _createElementVNode("th", null, "Gesamtsumme ohne MwSt.", -1)),
                                                    _createElementVNode("td", _hoisted_70, _toDisplayString(_unref(formatCurrency)(props.orderRequest.totalPrice)), 1)
                                                ]),
                                                _createElementVNode("tr", null, [
                                                    _createElementVNode("td", null, "zzgl. " + _toDisplayString(props.orderRequest.taxRate) + " % MwSt.", 1),
                                                    _createElementVNode("td", _hoisted_71, _toDisplayString(_unref(formatCurrency)(props.orderRequest.totalTax)), 1)
                                                ]),
                                                _createElementVNode("tr", _hoisted_72, [
                                                    _cache[67] || (_cache[67] = _createElementVNode("th", { class: "fs-5 text-primary" }, "Gesamtsumme inkl. MwSt.", -1)),
                                                    _createElementVNode("td", _hoisted_73, _toDisplayString(_unref(formatCurrency)(props.orderRequest.totalPriceInclTax)), 1)
                                                ])
                                            ])
                                        ]),
                                        _cache[68] || (_cache[68] = _createElementVNode("p", { class: "fw-bold m-0" }, "Alle Preise exkl. Versand!", -1))
                                    ])
                                ]),
                                (props.orderRequest.order == null)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        class: "btn btn-danger d-inline-flex align-items-center mt-4",
                                        onClick: removeOrderRequest
                                    }, [...(_cache[69] || (_cache[69] = [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "16",
                                                height: "16",
                                                fill: "currentColor",
                                                class: "bi bi-x-circle",
                                                viewBox: "0 0 16 16"
                                            }, [
                                                _createElementVNode("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" }),
                                                _createElementVNode("path", { d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" })
                                            ], -1),
                                            _createElementVNode("span", { class: "ms-2" }, "Anfrage/Angebot löschen", -1)
                                        ]))]))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                    _createElementVNode("div", _hoisted_74, [
                        _createElementVNode("div", _hoisted_75, [
                            _createElementVNode("div", _hoisted_76, [
                                _cache[81] || (_cache[81] = _createElementVNode("div", { class: "modal-header" }, [
                                    _createElementVNode("h1", {
                                        class: "modal-title fs-5 fw-bold",
                                        id: "createPositionModalLabel"
                                    }, "Neue Position"),
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn-close",
                                        "data-bs-dismiss": "modal",
                                        "aria-label": "Close"
                                    })
                                ], -1)),
                                _createElementVNode("form", {
                                    onSubmit: _withModifiers(createOrderPosition, ["prevent"])
                                }, [
                                    _createElementVNode("div", _hoisted_77, [
                                        _createElementVNode("div", _hoisted_78, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "number",
                                                class: "form-control",
                                                id: "newAmount",
                                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_unref(createOrderPositionForm).amount) = $event))
                                            }, null, 512), [
                                                [_vModelText, _unref(createOrderPositionForm).amount]
                                            ]),
                                            _cache[72] || (_cache[72] = _createElementVNode("label", { for: "newAmount" }, "Menge", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_79, [
                                            _withDirectives(_createElementVNode("input", {
                                                class: "form-check-input",
                                                type: "radio",
                                                id: "newPositionConfigurationOrProduct",
                                                value: "1",
                                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_unref(createOrderPositionForm).configurationOrProduct) = $event))
                                            }, null, 512), [
                                                [_vModelRadio, _unref(createOrderPositionForm).configurationOrProduct]
                                            ]),
                                            _cache[73] || (_cache[73] = _createElementVNode("label", {
                                                class: "form-check-label",
                                                for: "newPositionConfigurationOrProduct"
                                            }, "Konfiguration", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_80, [
                                            _withDirectives(_createElementVNode("input", {
                                                class: "form-check-input",
                                                type: "radio",
                                                id: "newPositionConfigurationOrProduct2",
                                                value: "2",
                                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_unref(createOrderPositionForm).configurationOrProduct) = $event))
                                            }, null, 512), [
                                                [_vModelRadio, _unref(createOrderPositionForm).configurationOrProduct]
                                            ]),
                                            _cache[74] || (_cache[74] = _createElementVNode("label", {
                                                class: "form-check-label",
                                                for: "newPositionConfigurationOrProduct2"
                                            }, "Produkt/Zubehör", -1))
                                        ]),
                                        (_unref(createOrderPositionForm).configurationOrProduct == 1)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                                                _createElementVNode("div", _hoisted_82, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        class: "form-check-input",
                                                        type: "radio",
                                                        id: "newPositionOption",
                                                        value: "1",
                                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_unref(createOrderPositionForm).option) = $event))
                                                    }, null, 512), [
                                                        [_vModelRadio, _unref(createOrderPositionForm).option]
                                                    ]),
                                                    _cache[75] || (_cache[75] = _createElementVNode("label", {
                                                        class: "form-check-label",
                                                        for: "newPositionOption"
                                                    }, " Existierende Konfiguration zuweisen ", -1))
                                                ]),
                                                _createElementVNode("div", _hoisted_83, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        class: "form-check-input",
                                                        type: "radio",
                                                        id: "newPositionOption2",
                                                        value: "2",
                                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_unref(createOrderPositionForm).option) = $event))
                                                    }, null, 512), [
                                                        [_vModelRadio, _unref(createOrderPositionForm).option]
                                                    ]),
                                                    _cache[76] || (_cache[76] = _createElementVNode("label", {
                                                        class: "form-check-label",
                                                        for: "newPositionOption2"
                                                    }, " Existierende Konfiguration kopieren ", -1))
                                                ]),
                                                (_unref(createOrderPositionForm).option == 1 && availableConfigurationsForAllocation.value.length > 0)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                                                        _cache[77] || (_cache[77] = _createElementVNode("label", { class: "mb-1" }, "Konfiguration", -1)),
                                                        _createVNode(_unref(Select), {
                                                            class: "w-100",
                                                            modelValue: _unref(createOrderPositionForm).configurationUuid,
                                                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((_unref(createOrderPositionForm).configurationUuid) = $event)),
                                                            options: availableConfigurationsForAllocation.value,
                                                            filter: "",
                                                            optionLabel: "name",
                                                            optionValue: "uuid",
                                                            placeholder: "Konfiguration wählen",
                                                            "append-to": "self"
                                                        }, null, 8, ["modelValue", "options"])
                                                    ]))
                                                    : _createCommentVNode("", true),
                                                (_unref(createOrderPositionForm).option == 2 && availableConfigurationsForCopy.value.length > 0)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                                                        _cache[78] || (_cache[78] = _createElementVNode("label", { class: "mb-1" }, "Konfiguration", -1)),
                                                        _createVNode(_unref(Select), {
                                                            class: "w-100",
                                                            modelValue: _unref(createOrderPositionForm).configurationUuid,
                                                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((_unref(createOrderPositionForm).configurationUuid) = $event)),
                                                            options: availableConfigurationsForCopy.value,
                                                            filter: "",
                                                            optionLabel: "name",
                                                            optionValue: "uuid",
                                                            placeholder: "Konfiguration wählen",
                                                            "append-to": "self"
                                                        }, null, 8, ["modelValue", "options"])
                                                    ]))
                                                    : _createCommentVNode("", true)
                                            ]))
                                            : _createCommentVNode("", true),
                                        (_unref(createOrderPositionForm).configurationOrProduct == 2)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                                                (availableAccessoryProducts.value.length > 0)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                                                        _cache[79] || (_cache[79] = _createElementVNode("label", { class: "mb-1" }, "Produkt", -1)),
                                                        _createVNode(_unref(Select), {
                                                            class: "w-100",
                                                            modelValue: _unref(createOrderPositionForm).accessoryProductUuid,
                                                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((_unref(createOrderPositionForm).accessoryProductUuid) = $event)),
                                                            options: availableAccessoryProducts.value,
                                                            filter: "",
                                                            optionLabel: "name",
                                                            optionValue: "uuid",
                                                            placeholder: "Produkt wählen",
                                                            "append-to": "self"
                                                        }, null, 8, ["modelValue", "options"])
                                                    ]))
                                                    : _createCommentVNode("", true)
                                            ]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _cache[80] || (_cache[80] = _createElementVNode("div", { class: "modal-footer" }, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "btn btn-secondary",
                                            "data-bs-dismiss": "modal"
                                        }, "Abbrechen"),
                                        _createElementVNode("button", {
                                            type: "submit",
                                            class: "btn btn-success d-inline-flex align-items-center"
                                        }, [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "16",
                                                height: "16",
                                                fill: "currentColor",
                                                class: "bi bi-check2",
                                                viewBox: "0 0 16 16"
                                            }, [
                                                _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                            ]),
                                            _createElementVNode("span", { class: "ms-2" }, "Speichern")
                                        ])
                                    ], -1))
                                ], 32)
                            ])
                        ])
                    ])
                ])),
                (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                    _createElementVNode("div", _hoisted_88, [
                        _createElementVNode("div", _hoisted_89, [
                            _createElementVNode("div", _hoisted_90, [
                                _cache[89] || (_cache[89] = _createElementVNode("div", { class: "modal-header" }, [
                                    _createElementVNode("h1", {
                                        class: "modal-title fs-5 fw-bold",
                                        id: "createOrderModalLabel"
                                    }, "Neue Bestellung"),
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn-close",
                                        "data-bs-dismiss": "modal",
                                        "aria-label": "Close"
                                    })
                                ], -1)),
                                _createElementVNode("form", {
                                    onSubmit: _cache[24] || (_cache[24] = _withModifiers(($event) => (createOrder()), ["prevent"]))
                                }, [
                                    _createElementVNode("div", _hoisted_91, [
                                        _createElementVNode("div", _hoisted_92, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control",
                                                id: "vatId",
                                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((_unref(checkoutForm).vatId) = $event))
                                            }, null, 512), [
                                                [_vModelText, _unref(checkoutForm).vatId]
                                            ]),
                                            _cache[82] || (_cache[82] = _createElementVNode("label", { for: "vatId" }, "Umsatzsteuer-ID/VAT-ID (optional)", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_93, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "date",
                                                class: "form-control",
                                                id: "requestedDeliveryDate",
                                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((_unref(checkoutForm).requestedDeliveryDate) = $event))
                                            }, null, 512), [
                                                [_vModelText, _unref(checkoutForm).requestedDeliveryDate]
                                            ]),
                                            _cache[83] || (_cache[83] = _createElementVNode("label", { for: "requestedDeliveryDate" }, "Gewünschtes Lieferdatum (optional)", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_94, [
                                            _withDirectives(_createElementVNode("select", {
                                                class: "form-select",
                                                id: "invoiceAddress",
                                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((_unref(checkoutForm).invoiceAddress) = $event)),
                                                required: ""
                                            }, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customerAddressList.value, (address) => {
                                                    return (_openBlock(), _createElementBlock("option", {
                                                        value: address.uuid
                                                    }, _toDisplayString(address.name), 9, _hoisted_95));
                                                }), 256))
                                            ], 512), [
                                                [_vModelSelect, _unref(checkoutForm).invoiceAddress]
                                            ]),
                                            _cache[84] || (_cache[84] = _createElementVNode("label", { for: "invoiceAddress" }, "Rechnungsadresse", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_96, [
                                            _withDirectives(_createElementVNode("select", {
                                                class: "form-select",
                                                id: "deliveryAddress",
                                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => ((_unref(checkoutForm).deliveryAddress) = $event)),
                                                required: ""
                                            }, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customerAddressList.value, (address) => {
                                                    return (_openBlock(), _createElementBlock("option", {
                                                        value: address.uuid
                                                    }, _toDisplayString(address.name), 9, _hoisted_97));
                                                }), 256))
                                            ], 512), [
                                                [_vModelSelect, _unref(checkoutForm).deliveryAddress]
                                            ]),
                                            _cache[85] || (_cache[85] = _createElementVNode("label", { for: "deliveryAddress" }, "Lieferadresse (muss mit Lieferland übereinstimmen!)", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_98, [
                                            _withDirectives(_createElementVNode("input", {
                                                class: "form-check-input",
                                                type: "checkbox",
                                                value: "1",
                                                id: "advertisingPurpose",
                                                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event) => ((_unref(checkoutForm).advertisingPurpose) = $event))
                                            }, null, 512), [
                                                [_vModelCheckbox, _unref(checkoutForm).advertisingPurpose]
                                            ]),
                                            _cache[86] || (_cache[86] = _createElementVNode("label", {
                                                class: "form-check-label",
                                                for: "advertisingPurpose"
                                            }, "Kunde ist einverstanden, dass sein konfiguriertes Layout für Werbezwecke von Seiten der FF genutzt werden darf. Dieser Zustimmung kann jederzeit widersprochen werden.", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_99, [
                                            _withDirectives(_createElementVNode("input", {
                                                class: "form-check-input",
                                                type: "checkbox",
                                                value: "1",
                                                id: "paymentByBankTransfer",
                                                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event) => ((_unref(checkoutForm).paymentByBankTransfer) = $event))
                                            }, null, 512), [
                                                [_vModelCheckbox, _unref(checkoutForm).paymentByBankTransfer]
                                            ]),
                                            _cache[87] || (_cache[87] = _createElementVNode("label", {
                                                class: "form-check-label",
                                                for: "paymentByBankTransfer"
                                            }, "Ich möchte per Überweisung auf Rechnung bezahlen.", -1))
                                        ])
                                    ]),
                                    _cache[88] || (_cache[88] = _createElementVNode("div", { class: "modal-footer" }, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "btn btn-secondary",
                                            "data-bs-dismiss": "modal"
                                        }, "Abbrechen"),
                                        _createElementVNode("button", {
                                            type: "submit",
                                            class: "btn btn-success d-inline-flex align-items-center"
                                        }, [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "16",
                                                height: "16",
                                                fill: "currentColor",
                                                class: "bi bi-check2",
                                                viewBox: "0 0 16 16"
                                            }, [
                                                _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                            ]),
                                            _createElementVNode("span", { class: "ms-2" }, "Bestellung erstellen")
                                        ])
                                    ], -1))
                                ], 32)
                            ])
                        ])
                    ])
                ]))
            ], 64));
        };
    }
});
